// extracted by mini-css-extract-plugin
module.exports = {"PhoneMockup":"PhoneMockup_PhoneMockup__6_0VA","PhoneMockupImage":"PhoneMockup_PhoneMockupImage__2bJfD","PhoneMockupContent":"PhoneMockup_PhoneMockupContent__2Vt41"};